// Lazily initialize reference popovers (issues, work items, merge requests,
// milestones, commits, ...) for the given elements.
export default function initPopovers(elements) {
  if (!elements.length) return;

  import(/* webpackChunkName: 'IssuablePopoverBundle' */ '/builds/gitlab/gitlab-ee/app/assets/javascripts/issuable/popover/index.js?vue3')
    .then(({ default: initIssuablePopovers }) => {
      initIssuablePopovers(elements);
    })
    .catch(() => {});
}
